module.exports = __webpack_public_path__ + "img/backward-10-seconds.463fdb22.svg";